import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    imports: [
        CommonModule,
        CardModule,
        ButtonModule,
        ToastModule
    ],
    providers: [MessageService]
})
export class LoginComponent {
  isLoading: boolean = false;

  constructor(
    private router: Router,
    private messageService: MessageService
  ) { }

  async enterGoVideo() {
    this.isLoading = true;

    try {
      // Simulate brief loading for smooth UX
      await this.simulateEntry();
      
      // Store mock user session (no authentication required)
      localStorage.setItem('mockUser', JSON.stringify({
        username: 'guest',
        loginTime: new Date().toISOString(),
        sessionType: 'splash-entry'
      }));

      this.messageService.add({
        severity: 'success',
        summary: 'Welcome to GoVideo',
        detail: 'Entering the application...'
      });

      // Navigate to session manager page
      setTimeout(() => {
        this.router.navigate(['/sessions']);
      }, 1000);

    } catch (error) {
      this.messageService.add({
        severity: 'error',
        summary: 'Entry Failed',
        detail: 'An unexpected error occurred. Please try again.'
      });
    } finally {
      this.isLoading = false;
    }
  }

  private simulateEntry(): Promise<void> {
    // Simulate brief loading for better UX
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve();
      }, 500);
    });
  }
}
